/**
 * Created by Stefano Mandruzzato on 20/11/18.
 */
'use strict';
export default class FakeLmrcApiService {

  constructor ($q, $log, $timeout, API_CONFIG, $ngRedux) {
    'ngInject';

    this._logger = $log.getInstance('FakeLmrcApiService');
    this._$q = $q;
    this.$timeout = $timeout;
    this.API_CONFIG = API_CONFIG;
    this.$ngRedux = $ngRedux;
    this._logger.log('instantiated');
    this._createSession_symRoundFetch = 3;
    this._startMigration_symRoundFetch = 0;
    this._getContactInfo_symRoundFetch = 0;
    this._putContactInfo_symRoundFetch = 0;
  }

  createSession (opts) {
    this._logger.debug('createSession', opts);
    let responses = [
      {status: 401, data: {error: 'google captcha non valid'}},
      {status: 400, data: {error: 'bad input'}},
      {status: 500, data: {error: 'internal server error'}},
      {status: 200, data: {status: 'OK'}}
    ];
    return this._$q((resolve, reject) =>{
      this.$timeout(() => {
        let response = responses[this._createSession_symRoundFetch];
        if (response.status >= 400){
          reject(response);
        } else {
          resolve(response);
        }
        this._createSession_symRoundFetch += 1;
      }, 1000);
    });
  }

  startMigration(opts) {
    this._logger.log('startMigration', opts);
    // 200 ok
    // 412 password errata o utente non trovato in CP
    // 404 dominio sconosciuto
    // 409 migrazione in corso, impossibile aggiungere nuove migrazioni
    let responses = [
      {status: 404, data: {error: 'email domain unknown'}},
      {status: 412, data: {error: 'invalid credential or email not found'}},
      {status: 409, data: {error: 'migration already in progress'}},
      {status: 200, data: {status: 'OK'}}
    ];
    return this._$q((resolve, reject) =>{
      this.$timeout(() => {
        let response = responses[this._startMigration_symRoundFetch];
        this._startMigration_symRoundFetch += 1;
        if (response.status >= 400){
          reject(response.status, response.data);
        } else {
          resolve(response.status, response.data);
        }

      }, 1000);
    });
  }


  getContactInfo (request) {
    let responses = [
      {status: 200, data: {
          "alternativeEmail": "yomama@gmail.com",
          "mobilePhone": "+393286666666"
        }}
    ];
    return this._$q((resolve, reject) =>{
      this.$timeout(() => {
        let response = responses[this._getContactInfo_symRoundFetch];
        if (response.status >= 400){
          reject(response.status, response.data);
        } else {
          resolve(response.data);
        }

      }, 1000);
    });
  }

  updateContactInfo (request) {
    this._logger.log('updateContactInfo', request);
    let responses = [
      {status: 200, data: {
          "alternativeEmail": "yomama@gmail.com",
          "mobilePhone": "+393286666666"
        }}
    ];
    return this._$q((resolve, reject) =>{
      this.$timeout(() => {
        let response = responses[this._putContactInfo_symRoundFetch];
        if (response.status >= 400){
          reject(response.status, response.data);
        } else {
          resolve(response.status, response.data);
        }

      }, 1000);
    });
  }
}



// WEBPACK FOOTER //
// ./client/components/api-service/fake-lmrc-api.service.js